<template>
    <section class="test-drive">
        <div class="select-brand__container container">
            <StepBar :step="1" step-name="Select a brand" />

            <h2 class="title">Please select a brand to book your test drive</h2>

            <div class="card">
                <div class="card__inner">
                    <ul class="select-brand__grid ul__no-bullet">
                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'abarth'}}">
                                <picture>
                                    <source type="image/webp" srcset="/img/logos/borderless/abarth.webp, /img/logos/borderless/abarth@2x.webp 2x" />
                                    <img class="img-responsive select-brand__image" srcset="/img/logos/borderless/abarth.jpg, /img/logos/borderless/abarth@2x.jpg 2x" alt="Abarth" />
                                </picture>
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'alfa-romeo'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/alfa-romeo.svg" alt="Alfa Romeo" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'citroen'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/citroen.svg" alt="Citroen" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'ds'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/ds.svg" alt="DS" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'fiat'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/fiat.svg" alt="Fiat" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'jeep'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/jeep.svg" alt="Jeep" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'leapmotor'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/leapmotor.svg" alt="Leapmotor" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'peugeot'}}">
                                <img class="img-responsive select-brand__image" src="/img/logos/borderless/peugeot.svg" alt="Peugeot" />
                            </router-link>
                        </li>

                        <li class="select-brand__logo">
                            <router-link :to="{ name: 'select-model', params: {brand: 'vauxhall'}}">
                                <img class="img-responsive select-brand__image" :src="brandLogoPath('/img/logos/borderless/vauxhall.svg', true)" alt="Vauxhall" />
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import StepBar from "../components/StepBar";
import { mapState } from "vuex";
import EventObject from "../../modules/tracking/EventObject";
import brandLogoPath from '../../modules/brandLogoPath';

export default {
    components: {
        StepBar,
    },
    created() {
        window.scrollTo(0, 0);
    },
    mounted() {
        if (this.step1Page === true) {
            new EventObject("New Car - Test Drive Form", "Revisit", "Step 1 Page").dispatch();
        } else {
            new EventObject("New Car - Test Drive Form", "Visited", "Step 1 Page").dispatch();
            this.$store.commit("setStep1Page", true);
        }
    },
    methods: {
        brandLogoPath,
    },
    computed: {
        ...mapState(["step1Page"]),
    },
};
</script>